import * as Sentry from '@sentry/react'

const EXTENSION_ORIGINS = [
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
    /^safari-(web-)?extension:\/\//i,
    /^ms-browser-extension:\/\//i,
    /^chrome:\/\//i,
    /^resource:\/\//i,
    /\/(chext_loader|chext_driver)\.js/i
]

const IGNORED_ERRORS = [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    /Failed to fetch dynamically imported module: (chrome|moz|safari-web)-extension:/i,
    /Denying load of (chrome|moz|safari-web)-extension:/i,
    'AbortError: The user aborted a request.',
    'Non-Error promise rejection captured',
    'Network request failed',
    'Load failed'
]

const isFromExtension = (event: Sentry.ErrorEvent): boolean => {
    const frames = event.exception?.values?.flatMap((v) => v.stacktrace?.frames ?? []) ?? []
    const named = frames.filter((f) => f.filename)
    if (named.length === 0) return false
    return named.every((f) => EXTENSION_ORIGINS.some((re) => re.test(f.filename as string)))
}

export function initSentry() {
    Sentry.init({
        dsn: 'https://ab398538822638b1c526bec4f3d0513a@o4509773786578944.ingest.us.sentry.io/4509774183727104',
        enabled: import.meta.env.VITE_ENV === 'production',
        sendDefaultPii: true,
        denyUrls: EXTENSION_ORIGINS,
        ignoreErrors: IGNORED_ERRORS,
        beforeSend(event) {
            return isFromExtension(event) ? null : event
        }
    })
}
